import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IShowEntryDetailsResponse } from '../../interfaces/showEntryDetailsResponse.interface';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ShowEntryPayWithPaypalComponent } from '../show-entry-pay-with-paypal/show-entry-pay-with-paypal.component';
import { ShowEntryPayWithCcComponent } from '../show-entry-pay-with-cc/show-entry-pay-with-cc.component';
import { MatButtonModule } from '@angular/material/button';
import { ShowEntryOrderItemsComponent } from '../../ui/show-entry-order-items/show-entry-order-items.component';


@Component({
  selector: 'equine-ui-nx-show-entry-checkout',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    ShowEntryPayWithPaypalComponent,
    ShowEntryPayWithCcComponent,
    MatButtonModule,
    MatDialogModule,
    ShowEntryOrderItemsComponent
  ],
  templateUrl: './show-entry-checkout.component.html',
  styleUrl: './show-entry-checkout.component.scss',
})
export class ShowEntryCheckoutComponent implements OnInit {

  paymentTypeSelected = signal<string | null>(null);
  paying = signal(false);

  entryDetailsIds: string[] = [];
  
  public data: {entryDetails: {shows: IShowEntryDetailsResponse[], greatTotal: number, products: any[]}, entryFee: boolean} = inject(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<ShowEntryCheckoutComponent>);

  ngOnInit(): void {
    this.entryDetailsIds = this.data.entryDetails.shows.map(each => each.id);
  }

  onSelectionChanged(event: MatSelectChange) {
    this.paymentTypeSelected.set(event.value);
  }

  onSuccess() {
    this.dialogRef.close(true);
  }

  onPaying(isPaying: boolean) {
    this.paying.set(isPaying);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

}
